import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EntitySearchFormComponent } from './entity-search-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { VarDirectiveModule } from '../../directives/ng-var';
import { TextHighlightPipeModule } from '../../pipes/text-highlight';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        VarDirectiveModule,
        TextHighlightPipeModule,
    ],
    exports: [EntitySearchFormComponent],
    declarations: [EntitySearchFormComponent],
    providers: [],
})
export class EntitySearchFormModule { }
